import { languages, findSupportedLanguageTag } from '@logto/language-kit';
import { z } from 'zod';
import ar from './locales/ar/index.js';
import cs from './locales/cs/index.js';
import de from './locales/de/index.js';
import en from './locales/en/index.js';
import es from './locales/es/index.js';
import faIR from './locales/fa-ir/index.js';
import fr from './locales/fr/index.js';
import it from './locales/it/index.js';
import ja from './locales/ja/index.js';
import ko from './locales/ko/index.js';
import nbNO from './locales/nb-no/index.js';
import plPL from './locales/pl-pl/index.js';
import ptBR from './locales/pt-br/index.js';
import ptPT from './locales/pt-pt/index.js';
import ru from './locales/ru/index.js';
import th from './locales/th/index.js';
import trTR from './locales/tr-tr/index.js';
import ukUA from './locales/uk-ua/index.js';
import zhCN from './locales/zh-cn/index.js';
import zhHK from './locales/zh-hk/index.js';
import zhTW from './locales/zh-tw/index.js';
export const builtInLanguages = [
    'ar',
    'cs',
    'de',
    'en',
    'es',
    'fa-IR',
    'fr',
    'it',
    'ja',
    'ko',
    'nb-NO',
    'pl-PL',
    'pt-PT',
    'pt-BR',
    'ru',
    'th',
    'tr-TR',
    'uk-UA',
    'zh-CN',
    'zh-HK',
    'zh-TW',
];
export const builtInLanguageOptions = builtInLanguages.map((languageTag) => ({
    value: languageTag,
    title: languages[languageTag],
}));
export const builtInLanguageTagGuard = z.enum(builtInLanguages);
const resource = {
    ar,
    cs,
    de,
    en,
    es,
    'fa-IR': faIR,
    fr,
    it,
    ja,
    ko,
    'nb-NO': nbNO,
    'pl-PL': plPL,
    'pt-PT': ptPT,
    'pt-BR': ptBR,
    ru,
    th,
    'tr-TR': trTR,
    'uk-UA': ukUA,
    'zh-CN': zhCN,
    'zh-HK': zhHK,
    'zh-TW': zhTW,
};
export const getDefaultLanguageTag = (language) => builtInLanguageTagGuard.parse(findSupportedLanguageTag(language ? [language] : [], builtInLanguages, 'en'));
export const isBuiltInLanguageTag = (language) => builtInLanguageTagGuard.safeParse(language).success;
export default resource;
